import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { environment } from './environments/environment';

window.dataLayer = window.dataLayer || [];

if (environment.gtmId) {
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  (function (w: Window, d: Document, s: string, l: string, i: string) {
    const f = d.getElementsByTagName(s)[0] as HTMLElement;
    const j = d.createElement(s) as HTMLScriptElement;
    const dl = l !== 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
    f.parentNode!.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', environment.gtmId);
}

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
